import './navbar.scss'

import _ from 'lodash'
import { Component, Watch } from 'vue-property-decorator'
import { faTimes, faUser } from '@fortawesome/free-solid-svg-icons'
import * as emojiFlags from 'emoji-flags'

import { User } from '@skinsoft/types'
import { workspaceSelectors, userSelectors } from '@skinsoft/selectors'
import { Proxy } from '@skinsoft/network'
import { AuthService } from '@skinsoft/auth'
import { TranslationDataStore, WorkspaceDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { Touchable } from '@skinsoft/ui'
import { ContextMenuModal } from './context-menu-modal'

export const DEFAULT_PROXY = new Proxy()

@Component({
    components: {
        sContextMenuModal: ContextMenuModal,
        sTouchable: Touchable,
    },
    props: ['title'],
    template: require('./navbar.html'),
})
export class Navbar extends ReactiveVue {
    public $authService: AuthService
    public title: string

    public $refs: {
        modal: ContextMenuModal
        navbar: HTMLElement
    }

    public user: User | null = null
    public userIcon = faUser
    public logOutIcon = faTimes
    public userSelectors = userSelectors
    private localeFlag: string | null = null
    private availableLocales: Array<{ key: string; flag: string }> = []

    private $workspaceDataStore: WorkspaceDataStore
    private $translationDataStore: TranslationDataStore

    public workspaceUserInfo: any = {
        selectedWorkspace: {},
        workspaceList: [],
    }
    public onlineMode = true
    protected proxy = DEFAULT_PROXY
    public created() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser)
        this.checkOnLine()
        this.$translationDataStore
            .filterLanguageListWithCacheContent(Object.keys(this.$i18n.messages))
            .subscribe(
                localeList =>
                    (this.availableLocales = localeList.map(key => ({
                        key,
                        flag: emojiFlags.countryCode(this.$i18n.messages[key].countryCode || key),
                    }))),
            )
    }

    public logOut() {
        if (!confirm(this.$t('navbar.logout') as string)) {
            return
        }

        return this.$authService.logOut()
    }

    public getWorkspaceName(workspace) {
        return workspaceSelectors.name(workspace, this.$i18n.locale)
    }

    public onTouchTimed = () => {
        this.$refs.modal.open()
    }

    private onUser(user: User | null) {
        this.user = user
        if (user) {
            this.$workspaceDataStore.workspaceList = userSelectors.userWorkspaces(user)
            if (localStorage.getItem('workspace')) {
                this.$workspaceDataStore.currentWorkspace = localStorage.getItem('workspace')!
            } else {
                this.$workspaceDataStore.currentWorkspace = userSelectors.defaultWorkspace(user).id
            }
        }
    }

    private get currentWorkspace(): string {
        return this.$workspaceDataStore.currentWorkspace
    }

    private set currentWorkspace(id: string) {
        this.$workspaceDataStore.currentWorkspace = id
    }

    public get currentWorkspaceInfo() {
        return this.$workspaceDataStore.currentWorkspaceInfo
    }

    private get workspaceList() {
        return this.$workspaceDataStore.workspaceList
    }

    @Watch('$i18n.locale', { immediate: true })
    private onLocaleChange() {
        // If the locale name doesn't correspond to the country code, specify it in the locale file (ex : fr-ca => ca)
        const countryCode = this.$t('countryCode')
        const localeId = countryCode !== 'countryCode' ? countryCode : this.$i18n.locale
        const code = emojiFlags.countryCode(localeId)
        this.localeFlag = code ? code.emoji : null
    }

    private checkOnLine() {
        this.onlineMode = window.navigator.onLine
        requestAnimationFrame(this.checkOnLine)
    }

    private changeLocale(localeKey: string) {
        this.$i18n.locale = localeKey
    }
}
